export const EMAILS_LOADED = "emails/load"
export const EMAILS_UPDATED = "emails/updated"